import type { ScreenTourMap } from './types';

/** Reportes. */
export const reportTours: ScreenTourMap = {
  '/reports/payments-by-date': {
    key: 'screen-payments-by-date',
    guide: 'aprobar-correcciones',
    steps: [
      { text: 'tours.paymentsByDate.welcome' },
      { text: 'tours.paymentsByDate.start', target: 'payments-by-date-start' },
      { text: 'tours.paymentsByDate.end', target: 'payments-by-date-end' },
      { text: 'tours.paymentsByDate.office', target: 'payments-by-date-office' },
      { text: 'tours.paymentsByDate.routes', target: 'payments-by-date-routes' },
      { text: 'tours.paymentsByDate.query', target: 'payments-by-date-query' },
      { text: 'tours.paymentsByDate.stats', target: 'payments-by-date-stats', whenMissing: 'center' },
      { text: 'tours.paymentsByDate.table', target: 'payments-by-date' },
      { text: 'tours.paymentsByDate.actions', target: 'payments-by-date-actions' },
      { text: 'tours.paymentsByDate.export', target: 'payments-by-date-export' },
    ],
  },
};
